import {TableDefinition} from '~/backend/src/connectors/db/dbDefinition/DbDefinitionMapperUtilities';


const tableDefinition : TableDefinition = {
    table   : 'CI_RSET',
    fieldMap: {
        id              : 'CIRS_ID',
        statusId        : 'CIRS_CIST_ID',
        origin          : 'CIRS_ORIGIN',
        module          : 'CIRS_MODULE',
        referenceTypeId : 'CIRS_CIRT_ID',
        srcItemTypeId   : 'CIRS_CIT_ID_SRC',
        destItemTypeId  : 'CIRS_CIT_ID_DEST',
        cardinality     : 'CIRS_CARDINALITY',
        description     : 'CIRS_DESCRIPTION',
        isImported      : 'CIRS_IS_IMPORTED',
        modifierUserId  : 'CIRS_MODIFIER',
        modificationTime: 'CIRS_MODIFICATION_TIME',
        uuid            : 'CIRS_UUID'
    }
}

export default tableDefinition;
